module.exports = __webpack_public_path__ + "media/images/career_camp/trees-ca1cd847c3e7c34a4871421fe2ccdf5b.svg";